import { Helmet } from "react-helmet";

// Components
import VideoEmbed from "./VideoEmbed/VideoEmbed";
import VideoHeader from "./VideoHeader/VideoHeader";
import VideoRelatedProduct from "./VideoRelatedProduct/VideoRelatedProduct";
import VideoRelated from "./VideoRelated/VideoRelated";

// CSS
import styles from "./video.module.scss";

const Video = (props) => {
    const { video } = props;
    const { description, title } = video || {};

    return (
        <div className={styles.video}>
            <Helmet>
                <title>{video?.title}</title>
                <meta name="title" content={title} />
                <meta name="description" content={description} />
                <meta name="robots" content="index, follow" />
            </Helmet>
            <VideoHeader {...props} />
            <VideoEmbed {...props} />
            <VideoRelatedProduct {...props} />
            <VideoRelated {...props} />
        </div>
    );
};

export default Video;
